import { render } from "./wordDetailTable.vue?vue&type=template&id=b08309ec&scoped=true"
import script from "./wordDetailTable.vue?vue&type=script&lang=js"
export * from "./wordDetailTable.vue?vue&type=script&lang=js"

import "./wordDetailTable.vue?vue&type=style&index=0&id=b08309ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08309ec"]])

export default __exports__